import requestDocumentTypeCodes from '@/utils/constants/hrrequest/requestDocumentTypeCodes';
import necessityCodes from '@/utils/constants/hrrequest/necessityCodes';

const documentNecessityConfigs = [
  {
    necessityId: necessityCodes.hygiene,
    documentTypes: [
      {
        id: requestDocumentTypeCodes.HRCertificadoMedicoHigiene,
      },
    ],
  },
  {
    necessityId: necessityCodes.feeding,
    documentTypes: [
      {
        id: requestDocumentTypeCodes.HRCertificadoMedicoAlimentacion,
      },
      {
        id:
          requestDocumentTypeCodes.HRFormularioInformeMedicoParaDietasEspeciales,
      },
    ],
  },
  {
    necessityId: necessityCodes.health,
    documentTypes: [
      {
        id: requestDocumentTypeCodes.HRCertificadoMedicoSalud,
        rules: 'required',
      },
    ],
  },
];

export default documentNecessityConfigs;
